import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  name: 'Maria',
  details: '45, mom',
  quote: "3 colds/month → 0 using elderberry protocol. It's changed our winter completely."
}, {
  name: 'Tom',
  details: '52, desk job',
  quote: 'Daily knee pain → walking pain-free. The turmeric rotation actually works better than my pills.'
}, {
  name: 'Sarah',
  details: '38',
  quote: 'Chronic migraines → 70% reduction. Willow + peppermint is my new go-to.'
}];
export function Testimonials() {
  return <section className="py-20 bg-[#f4f7f5]" data-id="element-195">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3c2a] mb-4" data-id="element-198">
            What Changes in 7 Days
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-199">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border-l-4 border-[#1a3c2a] relative" data-id="element-200">
              <Quote className="absolute top-4 right-4 text-[#c9a84c]/20 w-12 h-12" data-id="element-201" />
              <p className="text-[#5c4a32] text-lg italic mb-6 relative z-10" data-id="element-202">
                "{item.quote}"
              </p>
              <div data-id="element-203">
                <p className="font-bold text-[#1a3c2a]" data-id="element-204">{item.name}</p>
                <p className="text-sm text-gray-500" data-id="element-205">{item.details}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}